import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getPowerBiConfiguration } from '../../utils/principal-service/powerbi-endpoints';
import { ConfigPowerBI } from '../../utils/principal-service/powerbit-endpoints.types';

export const usePowerBI = (): UseQueryResult<ConfigPowerBI> =>
  useQuery({
    queryFn: getPowerBiConfiguration,
    queryKey: ['powerbi', 'configuration'],
    select: ({ data }) => data,
  });
